import { computed, ref } from 'vue'
import useApiRequest from '@/_core/hooks/useApiRequest'
import useEventEmitter from '@/_core/hooks/useEventEmitter'
import { getSpecialOffers } from '../services/basket'
import SpecialOffer from '../models/SpecialOffer'

export default function SpecialOffersController () {
  const { $emit, $on, $off } = useEventEmitter()

  const items = ref([])

  const itemsRequest = useApiRequest(getSpecialOffers)
  itemsRequest.$on('success', () => {
    items.value = itemsRequest.data.items.map(o => new SpecialOffer(o))
    $emit('requestUserItem-success', itemsRequest.data)
  })
  itemsRequest.$on('error', () => {
    $emit('requestUserItem-error', itemsRequest.errors)
  })

  const requestItems = async () => {
    await itemsRequest.request()
  }

  return {
    items,
    requestItems,
    isLoading: computed(() => itemsRequest.isLoading),
    $on,
    $off
  }
}
